import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserManualDirective } from './user-manual.directive';
import { UserManualEditorComponent } from './user-manual-editor.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [CommonModule, MatDialogModule, MatIconModule, MatButtonModule, UserManualDirective as any, UserManualEditorComponent as any],
  exports: [UserManualDirective as any],
})
export class UserManualModule {}
